import type { HelpFile } from '../../types/help'
import { SystemDetailTestIds } from '../../../testids/SystemDetailTestIds'

export const systemDetailHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [SystemDetailTestIds.systemDetailPage]:
      'Detail page of a target system — shows attributes, resources, connector, and termination behavior.',
    [SystemDetailTestIds.cardSystemDetails]:
      'Core attributes of this target system, including identifier, type, and ownership.',
    [SystemDetailTestIds.cardTitleConnector]:
      'Connector currently linked to this system, used to provision changes outbound or sync data inbound.',
    [SystemDetailTestIds.sectionAttributes]:
      'Attribute values configured on this target system.',
    [SystemDetailTestIds.sectionResources]:
      'Resources defined on this system that grants and assignments can target.',
    [SystemDetailTestIds.terminationActionLabel]:
      'Action applied to accounts in this system when their owning identity is terminated.',
    [SystemDetailTestIds.connectorCapabilityBanner]:
      'Indicates which provisioning operations the linked connector currently supports.',
    [SystemDetailTestIds.btnAddConnector]:
      'Link a connector to this system to enable provisioning and inbound sync.',
    [SystemDetailTestIds.btnDeleteSystem]:
      'Delete this target system. Refused with 409 when any resources, enforcement objects, or accounts still reference the system.',
    [SystemDetailTestIds.linkConnectorDetail]: null,
    [SystemDetailTestIds.colName]: null,
    [SystemDetailTestIds.colType]: null,
    [SystemDetailTestIds.colClassification]:
      'Classification of the resource — for example, sensitivity or compliance level.',
    [SystemDetailTestIds.colEoResource]:
      'Resource that this enforcement object belongs to on this target system.',
  },
}
